import Card from "./card.js";
export default class CaptionedImage extends Card {
  constructor(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    super(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f),
      (this.U = "ab-captioned-image"),
      (this.V = !0),
      (this.test = !1);
  }
  tt() {
    const t = {};
    return (
      (t[Card.it.st] = Card.et.ht),
      (t[Card.it.rt] = this.id),
      (t[Card.it.ot] = this.viewed),
      (t[Card.it.ct] = this.title),
      (t[Card.it.nt] = this.imageUrl),
      (t[Card.it.dt] = this.description),
      (t[Card.it.ut] = this.updated),
      (t[Card.it.lt] = this.created),
      (t[Card.it.ft] = this.categories),
      (t[Card.it.xt] = this.expiresAt),
      (t[Card.it.URL] = this.url),
      (t[Card.it.bt] = this.linkText),
      (t[Card.it.gt] = this.aspectRatio),
      (t[Card.it.jt] = this.extras),
      (t[Card.it.zt] = this.pinned),
      (t[Card.it.kt] = this.dismissible),
      (t[Card.it.qt] = this.clicked),
      (t[Card.it.vt] = this.test),
      t
    );
  }
}
